import { LoadingSpinner, QueryErrorAlert } from '@shared/components';
import { EVERYTHING_INVOICED_MESSAGE } from '../utils/invoiceableLines';
import type { StillToInvoiceView } from '../hooks/useInvoicingOverview';
import { StillToInvoicePanel } from './StillToInvoicePanel';

/** Read-only view of what is left to invoice. Rendered inside the Previously
 *  invoiced guard, so it carries no permission check of its own. */
export function StillToInvoiceSection({ isLoading, isError, refetch, content }: StillToInvoiceView) {
    if (!isLoading && !isError && !content) return null;

    return (
        <section aria-labelledby="still-to-invoice-heading" className="space-y-3">
            <h4 id="still-to-invoice-heading" className="text-sm font-semibold text-mp-foreground">
                Still to invoice
            </h4>

            {isLoading && <LoadingSpinner message="Loading still to invoice" className="p-4" />}

            {!isLoading && isError && (
                <QueryErrorAlert message="Failed to load what is still to invoice." onRetry={() => refetch()} />
            )}

            {!isLoading && !isError && content?.everythingInvoiced && (
                <p role="status" className="text-sm text-mp-muted">
                    {EVERYTHING_INVOICED_MESSAGE}
                </p>
            )}

            {!isLoading && !isError && content && !content.everythingInvoiced && <StillToInvoicePanel panel={content.panel} />}
        </section>
    );
}
